module.exports = __webpack_public_path__ + "img/rep-ashley.c141ec00.png";